import TimeSteps from '../../enums/TimeSteps';
export const toNumberPeriod = (period) => {
    const { since, before, span } = period;
    const sinceAsNumber = typeof since === 'string' ? parseInt(since, 10) : since;
    const beforeAsNumber = typeof before === 'string' ? parseInt(before, 10) : before;
    return { since: sinceAsNumber, before: beforeAsNumber, span };
};
export const getUnitOfTime = (span) => {
    switch (span) {
        case TimeSteps.maximum:
            return 'second';
        case TimeSteps.perQuarterHours:
            return 'minute';
        case TimeSteps.perHalfHours:
            return 'minute';
        case TimeSteps.perHours:
            return 'hour';
        case TimeSteps.per6Hours:
            return 'hour';
        case TimeSteps.perDays:
            return 'day';
        case TimeSteps.perWeek:
            return 'week';
        case TimeSteps.perMonth:
            return 'month';
        case TimeSteps.perYears:
            return 'year';
        default:
            return 'day';
    }
};
